import { useEffect } from 'react';

import api from '@mssgme/api';
import { useForceUpdate } from './useForceUpdate';

export function useAuth() {
    const forceUpdate = useForceUpdate();

    useEffect(() => {
        function handler() {
            forceUpdate();
        }

        api.on('changeAccessToken', handler);

        return () => {
            api.removeListener('changeAccessToken', handler);
        };
    }, []);

    return { accessToken: api.accessToken, isAuthenticated: api.isAuthenticated, user: api.user };
}
